import { AppShellProps, AppShell as MantineAppShell } from '@mantine/core';
import { AppHeader } from '../app-header';

export const AppShell = (props: AppShellProps) => {
  return (
    <MantineAppShell
      {...props}
      header={<AppHeader />}
      padding={0}
      styles={(theme) => ({
        main: {
          backgroundColor:
            theme.colorScheme === 'dark' ? theme.colors.dark[8] : '#fafbfc',
        },
      })}
    />
  );
};
